module.exports = __webpack_public_path__ + "static/media/nss.caaee941.png";